import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { type ApplicationConfig, importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { NoAuthGuard } from '@guards/no-auth.guard';
import { AuthInterceptor } from '@interceptors/http-interceptor';
import Aura from '@primeng/themes/aura';
import { AuthService } from '@services/auth/auth.service';
import { AuthApiService } from '@services/auth/auth-api.service';
import { ValidationService } from '@services/core/validation.service';
import { LayoutService } from '@services/layout/layout.service';
import { LoadingService } from '@services/shared/loading.service';
import { SweetAlertsService } from '@services/shared/sweet-alerts.service';
import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';
import { es } from 'primelocale/es.json';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes, withComponentInputBinding()),
		importProvidersFrom(BrowserModule, FormsModule, ReactiveFormsModule),
		provideHttpClient(withFetch(), withInterceptors([AuthInterceptor])),
		provideAnimations(),
		provideLottieOptions({ player: () => player }),
		providePrimeNG({
			theme: {
				preset: Aura,
				options: {
					prefix: 'p',
					darkModeSelector: 'none',
					cssLayer: false,
				},
			},
			ripple: true,
			translation: es,
		}),

		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		MessageService,
		LayoutService,
		AuthService,
		AuthGuard,
		NoAuthGuard,
		SweetAlertsService,
		ValidationService,
		ConfirmationService,
		LoadingService,
		DynamicDialogRef,
		DynamicDialogConfig,
		DialogService,
		AuthApiService,
	],
};
